import { fabric } from 'fabric';

// Adapted from here https://jsfiddle.net/krunalhshah/qcqa1oe9/
// Extending Fabric line class (https://developer.tizen.org/community/tip-tech/creating-custom-objects-fabric.js)
const Line = fabric.util.createClass(fabric.Line, {
  type: 'line',

  initialize(element, options) {
    options || (options = {});
    this.callSuper('initialize', element, options);

    // Set default options
    this.set({
      hasBorders: false,
      hasControls: false,
    });
  },

  toObject() {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      customProps: this.customProps,
    });
  },
});

export default Line;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/Items/LegacyLine.js